import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "hidden"];

  connect() {
    this.inputTarget.addEventListener("input", this.updateHiddenField.bind(this));
  }

  updateHiddenField(event) {
    const inputValue = event.target.value;
    const option = this.element.querySelector(`option[value="${inputValue}"]`);
    if (option) {
      const id = option.getAttribute("data-id");
      this.hiddenTarget.value = id;
    } else {
      this.hiddenTarget.value = "";
    }
  }
}
